// import React, { useState, useEffect } from 'react';
// import { Card, Table, Alert, Spinner, Form } from 'react-bootstrap';
// import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
// import { FaFileExcel } from 'react-icons/fa';
// import axios from 'axios';
// import { authHeader } from '../services/auth-header';
// import { BASE_URL } from '../services/Api';
// import { useNavigate, useLocation } from 'react-router-dom';
// import * as XLSX from 'xlsx';

// const StockDetailsReportsValue = () => {
//     const location = useLocation();

//     // State for API data and loading  
//     const [apiData, setApiData] = useState({
//         content: [],
//         pageNumber: 0,
//         pageSize: 10,
//         totalElements: 0,
//         totalPages: 0,
//         last: true
//     });
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [exporting, setExporting] = useState(false);

//     // State for sorting
//     const [sort, setSort] = useState({
//         field: 'productid',
//         direction: 'asc'
//     });

//     // Page size options
//     const pageSizeOptions = [
//         { value: 5, label: '5' },
//         { value: 10, label: '10' },
//         { value: 20, label: '20' },
//         { value: 50, label: '50' }
//     ];

//     const [productName, setProductName] = useState('');

//     useEffect(() => {
//         const delayDebounce = setTimeout(() => {
//             setApiData(prev => ({ ...prev, pageNumber: 0 }));
//             fetchStockReport();
//         }, 200);

//         return () => clearTimeout(delayDebounce);
//     }, [productName]);

//     // Initialize state from navigation if coming back
//     useEffect(() => {
//         if (location.state?.reportState) {
//             const { reportState } = location.state;
//             setApiData(reportState.apiData);
//             setSort(reportState.sort);
//             setLoading(false);
//         }
//     }, [location.state]);

//     // Function to fetch stock report data
//     const fetchStockReport = async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             // Get today's date for checkdate parameter
//             const today = new Date();
//             const todayFormatted = today.toISOString().split('T')[0];

//             // Construct query parameters for the new API
//             const params = new URLSearchParams({
//                 pageNumber: apiData.pageNumber,
//                 pageSize: apiData.pageSize,
//                 field: sort.field,
//                 direction: sort.direction,
//                 warehouseid: 1,
//                 checkdate: todayFormatted,
//                 productName: productName.trim(),
//             });

//             // API call to the new endpoint
//             const response = await axios.get(
//                 `${BASE_URL}stockreport/page/stocksummaryreport?${params}`,
//                 { headers: authHeader() }
//             );

//             setApiData(response.data);
//         } catch (err) {
//             setError(err.response?.data?.message || err.message || 'Failed to fetch stock report');
//             console.error('Error fetching stock report:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Function to fetch all data for export
//     const fetchAllDataForExport = async () => {
//         try {
//             setExporting(true);

//             // Get today's date
//             const today = new Date();
//             const todayFormatted = today.toISOString().split('T')[0];

//             // Fetch all data without pagination
//             const params = new URLSearchParams({
//                 pageNumber: 0,
//                 pageSize: 10000, // Large number to get all records
//                 field: sort.field,
//                 direction: sort.direction,
//                 warehouseid: 1,
//                 checkdate: todayFormatted,
//                 productName: productName.trim(),
//             });

//             const response = await axios.get(
//                 `${BASE_URL}stockreport/page/stocksummaryreport?${params}`,
//                 { headers: authHeader() }
//             );

//             return response.data.content;
//         } catch (err) {
//             console.error('Error fetching data for export:', err);
//             throw err;
//         }
//     };

//     // Export to Excel function
//     // Export to Excel function with proper headers
//     // Export to Excel function with colored headers
//     const exportToExcel = async () => {
//         try {
//             setExporting(true);

//             const allData = await fetchAllDataForExport();

//             if (!allData || allData.length === 0) {
//                 setError('No data available to export');
//                 setExporting(false);
//                 return;
//             }

//             // Create worksheet data
//             const worksheetData = [];

//             // Row 1: Main headers with colors
//             worksheetData.push([
//                 '#', 'P.ID', 'Product Name', 'Product Type',
//                 'INWARD', '', '', '', '', '',
//                 'OUTWARD', '', '', '', '', '',
//                 'CLOSING', '', ''
//             ]);

//             // Row 2: Sub headers
//             worksheetData.push([
//                 '#', 'P.ID', 'Product Name', 'Product Type',
//                 'Purchase Qty', 'Purchase Value', 'Production Qty', 'Production Value', 'Sales Return Qty', 'Sales Return Value',
//                 'Sale Qty', 'Sale Value', 'Production Issue', 'Production Value', 'Purchase Return', 'Purchase Value',
//                 'Closing Qty', 'WAC', 'Closing Value'
//             ]);

//             // Add data rows
//             allData.forEach((item, index) => {
//                 worksheetData.push([
//                     index + 1,
//                     item.productid ?? 'N/A',
//                     item.productname ?? 'N/A',
//                     item.producttype ?? 'N/A',
//                     Number(item.purchaseqty ?? 0).toFixed(2),
//                     item.purchasevalue ?? 0,
//                     Number(item.productioninwardqty ?? 0).toFixed(2),
//                     item.productioninwardvalue ?? 0,
//                     Number(item.salesreturnqty ?? 0).toFixed(2),
//                     item.salesreturnvalue ?? 0,
//                     Number(item.saleqty ?? 0).toFixed(2),
//                     item.salevalue ?? 0,
//                     Number(item.productionoutwardqty ?? 0).toFixed(2),
//                     item.productionoutwardvalue ?? 0,
//                     Number(item.purchasereturnqty ?? 0).toFixed(2),
//                     item.purchasereturnvalue ?? 0,
//                     Number(item.closingqty ?? 0).toFixed(2),
//                     item.wac ?? 0,
//                     item.closingvalue ?? 0
//                 ]);
//             });

//             // Create workbook
//             const wb = XLSX.utils.book_new();
//             const ws = XLSX.utils.aoa_to_sheet(worksheetData);

//             // Merge cells for main headers
//             if (!ws['!merges']) ws['!merges'] = [];
//             ws['!merges'].push(
//                 { s: { r: 0, c: 4 }, e: { r: 0, c: 9 } },   // INWARD (col 4 to 9)
//                 { s: { r: 0, c: 10 }, e: { r: 0, c: 15 } }, // OUTWARD (col 10 to 15)
//                 { s: { r: 0, c: 16 }, e: { r: 0, c: 18 } }  // CLOSING (col 16 to 18)
//             );

//             // Apply colors to headers (INWARD, OUTWARD, CLOSING)
//             if (!ws['!cols']) ws['!cols'] = [];

//             // Style for INWARD header (blue background, white text)
//             // Style for OUTWARD header (orange background, dark text)
//             // Style for CLOSING header (green background, white text)

//             // Set column widths
//             ws['!cols'] = [
//                 { wch: 8 },   // #
//                 { wch: 10 },  // P.ID
//                 { wch: 35 },  // Product Name
//                 { wch: 20 },  // Product Type
//                 { wch: 15 }, { wch: 18 }, { wch: 15 }, { wch: 18 }, { wch: 18 }, { wch: 20 },
//                 { wch: 12 }, { wch: 15 }, { wch: 18 }, { wch: 20 }, { wch: 18 }, { wch: 20 },
//                 { wch: 15 }, { wch: 12 }, { wch: 18 }
//             ];

//             // Add styling to cells
//             // Note: xlsx doesn't support colors directly, we need to use xlsx-style for colors
//             // For now, we'll create a simple HTML export with colors

//             // Alternative: Create HTML with colors for better visual
//             const htmlContent = generateHTMLWithColors(allData);

//             // Create blob and download
//             const blob = new Blob([htmlContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//             const link = document.createElement('a');
//             const url = URL.createObjectURL(blob);
//             const today = new Date();
//             const fileName = `Stock_Report_${today.toISOString().split('T')[0]}.xls`;

//             link.href = url;
//             link.download = fileName;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             URL.revokeObjectURL(url);

//             setExporting(false);
//         } catch (err) {
//             setError('Failed to export data: ' + (err.message || 'Unknown error'));
//             setExporting(false);
//             console.error('Export error:', err);
//         }
//     };

//     // Helper function to generate HTML with colors
//     const generateHTMLWithColors = (data) => {
//         let html = `
//         <html>
//         <head>
//             <meta charset="UTF-8">
//             <title>Stock Report</title>
//             <style>
//                 table {
//                     border-collapse: collapse;
//                     width: 100%;
//                     font-family: Arial, sans-serif;
//                 }
//                 th, td {
//                     border: 1px solid #ddd;
//                     padding: 8px;
//                     text-align: left;
//                 }
//                 .inward-header {
//                     background-color: #007bff;
//                     color: white;
//                     text-align: center;
//                     font-weight: bold;
//                 }
//                 .outward-header {
//                     background-color: #ffc107;
//                     color: #000;
//                     text-align: center;
//                     font-weight: bold;
//                 }
//                 .closing-header {
//                     background-color: #28a745;
//                     color: white;
//                     text-align: center;
//                     font-weight: bold;
//                 }
//                 .sub-header {
//                     background-color: #f2f2f2;
//                     font-weight: bold;
//                 }
//                 .numeric-cell {
//                     text-align: right;
//                 }
//             </style>
//         </head>
//         <body>
//             <table>
//                 <thead>
//                     <tr>
//                         <th rowspan="2">#</th>
//                         <th rowspan="2">P.ID</th>
//                         <th rowspan="2">Product Name</th>
//                         <th rowspan="2">Product Type</th>
//                         <th colspan="6" class="inward-header">INWARD</th>
//                         <th colspan="6" class="outward-header">OUTWARD</th>
//                         <th colspan="3" class="closing-header">CLOSING</th>
//                     </tr>
//                     <tr class="sub-header">
//                         <th>Purchase Qty</th><th>Purchase Value</th><th>Production Qty</th>
//                         <th>Production Value</th><th>Sales Return Qty</th><th>Sales Return Value</th>
//                         <th>Sale Qty</th><th>Sale Value</th><th>Production Issue</th>
//                         <th>Production Value</th><th>Purchase Return</th><th>Purchase Value</th>
//                         <th>Closing Qty</th><th>WAC</th><th>Closing Value</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//     `;

//         data.forEach((item, index) => {
//             html += `
//             <tr>
//                 <td>${index + 1}</td>
//                 <td>${item.productid ?? 'N/A'}</td>
//                 <td>${item.productname ?? 'N/A'}</td>
//                 <td>${item.producttype ?? 'N/A'}</td>
//                 <td class="numeric-cell">${Number(item.purchaseqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.purchasevalue ?? 0}</td>
//                 <td class="numeric-cell">${Number(item.productioninwardqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.productioninwardvalue ?? 0}</td>
//                 <td class="numeric-cell">${Number(item.salesreturnqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.salesreturnvalue ?? 0}</td>
//                 <td class="numeric-cell">${Number(item.saleqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.salevalue ?? 0}</td>
//                 <td class="numeric-cell">${Number(item.productionoutwardqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.productionoutwardvalue ?? 0}</td>
//                 <td class="numeric-cell">${Number(item.purchasereturnqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.purchasereturnvalue ?? 0}</td>
//                 <td class="numeric-cell">${Number(item.closingqty ?? 0).toFixed(2)}</td>
//                 <td class="numeric-cell">${item.wac ?? 0}</td>
//                 <td class="numeric-cell">${item.closingvalue ?? 0}</td>
//             </tr>
//         `;
//         });

//         html += `
//                 </tbody>
//             </table>
//         </body>
//         </html>
//     `;

//         return html;
//     };

//     // Fetch data when component mounts
//     useEffect(() => {
//         fetchStockReport();
//     }, []);

//     // Page size handler
//     const handlePageSizeChange = (e) => {
//         const newSize = parseInt(e.target.value);
//         setApiData(prev => ({
//             ...prev,
//             pageSize: newSize,
//             pageNumber: 0
//         }));
//     };

//     // Sort handler
//     const handleSort = (field) => {
//         const newDirection = sort.field === field && sort.direction === 'asc' ? 'desc' : 'asc';
//         setSort({
//             field,
//             direction: newDirection
//         });
//         setApiData(prev => ({ ...prev, pageNumber: 0 }));
//     };

//     // Pagination handlers
//     const handlePageChange = (page) => {
//         setApiData(prev => ({ ...prev, pageNumber: page }));
//     };

//     const handlePreviousPage = () => {
//         if (apiData.pageNumber > 0) {
//             setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber - 1 }));
//         }
//     };

//     const handleNextPage = () => {
//         if (!apiData.last) {
//             setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber + 1 }));
//         }
//     };

//     // Render pagination numbers
//     const renderPagination = () => {
//         const totalPages = apiData.totalPages;
//         const currentPage = apiData.pageNumber;
//         const siblingsCount = 2;
//         const firstPage = 0;
//         const lastPage = totalPages - 1;
//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + siblingsCount);

//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button
//                     key={firstPage}
//                     className={`stock-page-btn ${currentPage === firstPage ? 'active' : ''}`}
//                     onClick={() => handlePageChange(firstPage)}
//                 >
//                     {firstPage + 1}
//                 </button>
//             );
//             if (startPage > firstPage + 2) {
//                 pageNumbers.push(<span key="dots-start" className="stock-page-dots">...</span>);
//             }
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`stock-page-btn  ${currentPage === i ? 'active' : ''}`}
//                     onClick={() => handlePageChange(i)}
//                 >
//                     {i + 1}
//                 </button>
//             );
//         }

//         if (endPage < lastPage - 1) {
//             if (endPage < lastPage - 2) {
//                 pageNumbers.push(<span key="dots-end" className="stock-page-dots">...</span>);
//             }
//             pageNumbers.push(
//                 <button
//                     key={lastPage}
//                     className={`stock-page-btn  ${currentPage === lastPage ? 'active' : ''}`}
//                     onClick={() => handlePageChange(lastPage)}
//                 >
//                     {lastPage + 1}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     };

//     // Fetch data when pagination or sorting changes
//     useEffect(() => {
//         fetchStockReport();
//     }, [apiData.pageNumber, apiData.pageSize, sort.field, sort.direction]);

//     // Perfect Sync Scrolling Effect
//     useEffect(() => {
//         const syncScroll = () => {
//             const headerWrapper = document.querySelector('.stock-table-header-wrapper');
//             const bodyWrapper = document.querySelector('.stock-table-body-wrapper');

//             if (!headerWrapper || !bodyWrapper) return;

//             const handleBodyScroll = () => {
//                 headerWrapper.scrollLeft = bodyWrapper.scrollLeft;
//             };

//             const handleHeaderScroll = () => {
//                 bodyWrapper.scrollLeft = headerWrapper.scrollLeft;
//             };

//             bodyWrapper.addEventListener('scroll', handleBodyScroll);
//             headerWrapper.addEventListener('scroll', handleHeaderScroll);

//             return () => {
//                 bodyWrapper.removeEventListener('scroll', handleBodyScroll);
//                 headerWrapper.removeEventListener('scroll', handleHeaderScroll);
//             };
//         };

//         const timer = setTimeout(() => {
//             syncScroll();
//             const headerWrapper = document.querySelector('.stock-table-header-wrapper');
//             const bodyWrapper = document.querySelector('.stock-table-body-wrapper');
//             if (headerWrapper && bodyWrapper) {
//                 headerWrapper.scrollLeft = bodyWrapper.scrollLeft;
//             }
//         }, 150);

//         return () => {
//             clearTimeout(timer);
//         };
//     }, [apiData.content, loading]);

//     return (
//         <Card className="mt-4 stock-card">
//             <Card.Header className="stock-header">
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <h4 className="mb-0">Stock In Hand Report</h4>

//                 </div>
//                 <button
//                     onClick={exportToExcel}
//                     disabled={exporting || loading || apiData.content.length === 0}
//                     style={{
//                         backgroundColor: '#28a745',
//                         color: 'white',
//                         border: 'none',
//                         padding: '8px 16px',
//                         borderRadius: '6px',
//                         cursor: exporting ? 'not-allowed' : 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '8px',
//                         fontSize: '14px',
//                         fontWeight: '500'
//                     }}
//                 >
//                     {exporting ? (
//                         <>
//                             <Spinner animation="border" size="sm" />
//                             <span>Exporting...</span>
//                         </>
//                     ) : (
//                         <>
//                             <FaFileExcel size={18} />
//                             <span>Export to Excel</span>
//                         </>
//                     )}
//                 </button>
//             </Card.Header>

//             <Card.Body>
//                 {/* Error Alert */}
//                 {error && (
//                     <Alert variant="danger" onClose={() => setError(null)} dismissible>
//                         {error}
//                     </Alert>
//                 )}

//                 {/* Controls Section */}
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", paddingBottom: '8px' }}>
//                     <div className="stock-entries-control">
//                         <span className="stock-entries-label">Show entries:</span>
//                         <Form.Select
//                             className="stock-entries-select"
//                             onChange={handlePageSizeChange}
//                             value={apiData.pageSize}
//                             disabled={loading}
//                             style={{ width: '100px', display: 'inline-block' }}
//                         >
//                             {pageSizeOptions.map((item) => (
//                                 <option key={item.value} value={item.value}>{item.label}</option>
//                             ))}
//                         </Form.Select>
//                     </div>

//                     <div className="stock-search-box mt-2 mt-md-0">
//                         <input
//                             type="search"
//                             className="form-control"
//                             placeholder="Search by Product Name"
//                             value={productName}
//                             onChange={(e) => setProductName(e.target.value)}
//                             style={{ maxWidth: '300px' }}
//                         />
//                     </div>
//                 </div>

//                 {/* Rest of your table code remains same... */}
//                 {/* Table Section */}
//                 {loading ? (
//                     <div className="text-center py-5">
//                         <Spinner animation="border" role="status" variant="primary">
//                             <span className="visually-hidden">Loading...</span>
//                         </Spinner>
//                         <p className="mt-2">Loading stock data...</p>
//                     </div>
//                 ) : apiData.content.length > 0 ? (
//                     <>
//                         {/* Main Container with Perfect Sync */}
//                         <div className="stock-table-main-container">

//                             {/* Header Table - Fixed at top */}
//                             <div className="stock-table-header-wrapper">
//                                 <Table bordered className="stock-table-common stock-table-header">
//                                     <colgroup>
//                                         <col /> {/* # */}
//                                         <col /> {/* Product ID */}
//                                         <col /> {/* Product Name */}
//                                         <col /> {/* Product Type */}
//                                         <col /><col /><col /><col /><col /><col /> {/* INWARD */}
//                                         <col /><col /><col /><col /><col /><col /> {/* OUTWARD */}
//                                         <col /><col /><col /> {/* CLOSING */}
//                                     </colgroup>
//                                     <thead>
//                                         <tr>
//                                             <th rowSpan="2">#</th>
//                                             <th rowSpan="2" style={{ cursor: 'pointer' }} onClick={() => handleSort('productid')}>
//                                                 P.ID
//                                                 {sort.field === 'productid' && (
//                                                     <span className="ms-1">{sort.direction === 'asc' ? '↑' : '↓'}</span>
//                                                 )}
//                                             </th>
//                                             <th rowSpan="2">Product Name</th>
//                                             <th rowSpan="2">Product Type</th>
//                                             <th colSpan="6" className="text-center bg-primary text-white py-1">INWARD</th>
//                                             <th colSpan="6" className="text-center bg-warning text-dark py-1">OUTWARD</th>
//                                             <th colSpan="3" className="text-center bg-success text-white py-1">CLOSING</th>
//                                         </tr>
//                                         <tr>
//                                             <th>Purchase Qty</th><th>Purchase Value</th><th>Production Qty</th>
//                                             <th>Production Value</th><th>Sales Return Qty</th><th>Sales Return Value</th>
//                                             <th>Sale Qty</th><th>Sale Value</th><th>Production Issue</th>
//                                             <th>Production Value</th><th>Purchase Return</th><th>Purchase Value</th>
//                                             <th>Closing Qty</th><th>WAC</th><th>Closing Value</th>
//                                         </tr>
//                                     </thead>
//                                 </Table>
//                             </div>

//                             {/* Body Table - Scrollable */}
//                             <div className="stock-table-body-wrapper" id="stock-table-body">
//                                 <Table bordered className="stock-table-common stock-table-body">
//                                     <colgroup>
//                                         <col /><col /><col /><col />
//                                         <col /><col /><col /><col /><col /><col />
//                                         <col /><col /><col /><col /><col /><col />
//                                         <col /><col /><col />
//                                     </colgroup>
//                                     <tbody>
//                                         {apiData.content.map((item, index) => (
//                                             <tr key={item.productid}>
//                                                 <td>{index + 1}</td>
//                                                 <td>{item.productid ?? 'N/A'}</td>
//                                                 <td className="text-start">{item.productname ?? 'N/A'}</td>
//                                                 <td>{item.producttype ?? 'N/A'}</td>

//                                                 <td className="numeric-cell">{Number(item.purchaseqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.purchasevalue ?? 0}</td>
//                                                 <td className="numeric-cell">{Number(item.productioninwardqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.productioninwardvalue ?? 0}</td>
//                                                 <td className="numeric-cell">{Number(item.salesreturnqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.salesreturnvalue ?? 0}</td>

//                                                 <td className="numeric-cell">{Number(item.saleqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.salevalue ?? 0}</td>
//                                                 <td className="numeric-cell">{Number(item.productionoutwardqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.productionoutwardvalue ?? 0}</td>
//                                                 <td className="numeric-cell">{Number(item.purchasereturnqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.purchasereturnvalue ?? 0}</td>

//                                                 <td className="numeric-cell">{Number(item.closingqty ?? 0).toFixed(1)}</td>
//                                                 <td className="numeric-cell">{item.wac ?? 0}</td>
//                                                 <td className="numeric-cell">{item.closingvalue ?? 0}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </Table>
//                             </div>
//                         </div>

//                         {/* Pagination Controls */}
//                         <div className="stock-pagination mt-2">
//                             <span className="stock-pagination-info">
//                                 Showing {apiData.content.length} of {apiData.totalElements} entries
//                             </span>

//                             <div className="stock-pagination-controls">
//                                 <button
//                                     className={`brand-pagination-btn ${apiData.pageNumber === 0 ? 'disabled' : ''}`}
//                                     onClick={handlePreviousPage}
//                                     disabled={apiData.pageNumber === 0 || loading}
//                                 >
//                                     <IoIosArrowBack />
//                                 </button>

//                                 <div className="stock-pagination-pages">
//                                     {renderPagination()}
//                                 </div>

//                                 <button
//                                     className={`brand-pagination-btn ${apiData.last ? 'disabled' : ''}`}
//                                     onClick={handleNextPage}
//                                     disabled={apiData.last || loading}
//                                 >
//                                     <IoIosArrowForward />
//                                 </button>
//                             </div>
//                         </div>
//                     </>
//                 ) : (
//                     /* No Data Message in Table Body */
//                     <div className="stock-table-main-container">
//                         {/* Header Table - Still show header even when no data */}
//                         <div className="stock-table-header-wrapper">
//                             <Table bordered className="stock-table-common stock-table-header">
//                                 <colgroup>
//                                     <col /><col /><col /><col />
//                                     <col /><col /><col /><col /><col /><col />
//                                     <col /><col /><col /><col /><col /><col />
//                                     <col /><col /><col />
//                                 </colgroup>
//                                 <thead className="table-dark">
//                                     <tr>
//                                         <th rowSpan="2">#</th>
//                                         <th rowSpan="2" style={{ cursor: 'pointer' }} onClick={() => handleSort('productid')}>
//                                             P.ID
//                                             {sort.field === 'productid' && (
//                                                 <span className="ms-1">{sort.direction === 'asc' ? '↑' : '↓'}</span>
//                                             )}
//                                         </th>
//                                         <th rowSpan="2">Product Name</th>
//                                         <th rowSpan="2">Product Type</th>
//                                         <th colSpan="6" className="text-center bg-primary text-white py-1">INWARD</th>
//                                         <th colSpan="6" className="text-center bg-warning text-dark py-1">OUTWARD</th>
//                                         <th colSpan="3" className="text-center bg-success text-white py-1">CLOSING</th>
//                                     </tr>
//                                     <tr>
//                                         <th>Purchase Qty</th><th>Purchase Value</th><th>Production Qty</th>
//                                         <th>Production Value</th><th>Sales Return Qty</th><th>Sales Return Value</th>
//                                         <th>Sale Qty</th><th>Sale Value</th><th>Production Issue</th>
//                                         <th>Production Value</th><th>Purchase Return</th><th>Purchase Value</th>
//                                         <th>Closing Qty</th><th>WAC</th><th>Closing Value</th>
//                                     </tr>
//                                 </thead>
//                             </Table>
//                         </div>

//                         {/* Body Table with No Data Message */}
//                         <div className="stock-table-body-wrapper" id="stock-table-body">
//                             <Table bordered className="stock-table-common stock-table-body">
//                                 <colgroup>
//                                     <col /><col /><col /><col />
//                                     <col /><col /><col /><col /><col /><col />
//                                     <col /><col /><col /><col /><col /><col />
//                                     <col /><col /><col />
//                                 </colgroup>
//                                 <tbody>
//                                     <tr>
//                                         <td colSpan="19" className="text-center py-4">
//                                             <h5>
//                                                 {productName.trim() ?
//                                                     `No stock data found for product: "${productName}"` :
//                                                     'No stock data available'
//                                                 }
//                                             </h5>
//                                             <p className="text-muted">
//                                                 {productName.trim() ?
//                                                     'Try searching with a different product name' :
//                                                     'No data found for today\'s date'
//                                                 }
//                                             </p>
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </Table>
//                         </div>
//                     </div>
//                 )}
//             </Card.Body>
//         </Card>
//     );
// };

// export default StockDetailsReportsValue;




import React, { useState, useEffect } from 'react';
import { Card, Table, Alert, Spinner, Form } from 'react-bootstrap';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { FaFileExcel } from 'react-icons/fa';
import axios from 'axios';
import { authHeader } from '../services/auth-header';
import { BASE_URL } from '../services/Api';
import { useNavigate, useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';

const StockDetailsReportsValue = () => {
    const location = useLocation();

    // State for API data and loading
    const [apiData, setApiData] = useState({
        content: [],
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0,
        last: true
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [exporting, setExporting] = useState(false);

    // State for sorting
    const [sort, setSort] = useState({
        field: 'productid',
        direction: 'asc'
    });

    // Page size options
    const pageSizeOptions = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 50, label: '50' }
    ];

    const [productName, setProductName] = useState('');

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setApiData(prev => ({ ...prev, pageNumber: 0 }));
            fetchStockReport();
        }, 200);

        return () => clearTimeout(delayDebounce);
    }, [productName]);

    // Initialize state from navigation if coming back
    useEffect(() => {
        if (location.state?.reportState) {
            const { reportState } = location.state;
            setApiData(reportState.apiData);
            setSort(reportState.sort);
            setLoading(false);
        }
    }, [location.state]);

    // Function to fetch stock report data
    const fetchStockReport = async () => {
        try {
            setLoading(true);
            setError(null);

            // Get today's date for checkdate parameter
            const today = new Date();
            const todayFormatted = today.toISOString().split('T')[0];

            // Construct query parameters for the new API
            const params = new URLSearchParams({
                pageNumber: apiData.pageNumber,
                pageSize: apiData.pageSize,
                field: sort.field,
                direction: sort.direction,
                warehouseid: 1,
                checkdate: todayFormatted,
                productName: productName.trim(),
            });

            // API call to the new endpoint
            const response = await axios.get(
                `${BASE_URL}stockreport/page/stocksummaryreport?${params}`,
                { headers: authHeader() }
            );

            setApiData(response.data);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to fetch stock report');
            console.error('Error fetching stock report:', err);
        } finally {
            setLoading(false);
        }
    };

    // Function to fetch all data for export
    const fetchAllDataForExport = async () => {
        try {
            setExporting(true);

            // Get today's date
            const today = new Date();
            const todayFormatted = today.toISOString().split('T')[0];

            // Fetch all data without pagination
            const params = new URLSearchParams({
                pageNumber: 0,
                pageSize: 10000, // Large number to get all records
                field: sort.field,
                direction: sort.direction,
                warehouseid: 1,
                checkdate: todayFormatted,
                productName: productName.trim(),
            });

            const response = await axios.get(
                `${BASE_URL}stockreport/page/stocksummaryreport?${params}`,
                { headers: authHeader() }
            );

            return response.data.content;
        } catch (err) {
            console.error('Error fetching data for export:', err);
            throw err;
        }
    };

    // Export to Excel function with proper headers
    // Export to Excel function with colored headers
    const exportToExcel = async () => {
        try {
            setExporting(true);

            const allData = await fetchAllDataForExport();

            if (!allData || allData.length === 0) {
                setError('No data available to export');
                setExporting(false);
                return;
            }

            // Create worksheet data
            const worksheetData = [];

            // Row 1: Main headers with colors
            worksheetData.push([
                '#', 'P.ID', 'Product Name', 'Part No', 'Product Type',
                'INWARD', '', '', '', '', '',
                'OUTWARD', '', '', '', '', '',
                'CLOSING', '', ''
            ]);

            // Row 2: Sub headers
            worksheetData.push([
                '#', 'P.ID', 'Product Name', 'Part No', 'Product Type',
                'Purchase Qty', 'Purchase Value', 'Production Qty', 'Production Value', 'Sales Return Qty', 'Sales Return Value',
                'Sale Qty', 'Sale Value', 'Production Issue', 'Production Value', 'Purchase Return', 'Purchase Value',
                'Closing Qty', 'WAC', 'Closing Value'
            ]);

            // Add data rows
            allData.forEach((item, index) => {
                worksheetData.push([
                    index + 1,
                    item.productid ?? 'N/A',
                    item.productname ?? 'N/A',
                    item.partno ?? 'N/A',  // Added partno field
                    item.producttype ?? 'N/A',
                    Number(item.purchaseqty ?? 0).toFixed(2),
                    item.purchasevalue ?? 0,
                    Number(item.productioninwardqty ?? 0).toFixed(2),
                    item.productioninwardvalue ?? 0,
                    Number(item.salesreturnqty ?? 0).toFixed(2),
                    item.salesreturnvalue ?? 0,
                    Number(item.saleqty ?? 0).toFixed(2),
                    item.salevalue ?? 0,
                    Number(item.productionoutwardqty ?? 0).toFixed(2),
                    item.productionoutwardvalue ?? 0,
                    Number(item.purchasereturnqty ?? 0).toFixed(2),
                    item.purchasereturnvalue ?? 0,
                    Number(item.closingqty ?? 0).toFixed(2),
                    item.wac ?? 0,
                    item.closingvalue ?? 0
                ]);
            });

            // Create workbook
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(worksheetData);

            // Merge cells for main headers (adjusting column indices due to added Part No)
            if (!ws['!merges']) ws['!merges'] = [];
            ws['!merges'].push(
                { s: { r: 0, c: 5 }, e: { r: 0, c: 10 } },   // INWARD (col 5 to 10)
                { s: { r: 0, c: 11 }, e: { r: 0, c: 16 } }, // OUTWARD (col 11 to 16)
                { s: { r: 0, c: 17 }, e: { r: 0, c: 19 } }  // CLOSING (col 17 to 19)
            );

            // Set column widths
            ws['!cols'] = [
                { wch: 8 },   // #
                { wch: 10 },  // P.ID
                { wch: 35 },  // Product Name
                { wch: 20 },  // Part No
                { wch: 20 },  // Product Type
                { wch: 15 }, { wch: 18 }, { wch: 15 }, { wch: 18 }, { wch: 18 }, { wch: 20 },
                { wch: 12 }, { wch: 15 }, { wch: 18 }, { wch: 20 }, { wch: 18 }, { wch: 20 },
                { wch: 15 }, { wch: 12 }, { wch: 18 }
            ];

            // Generate HTML with colors
            const htmlContent = generateHTMLWithColors(allData);

            // Create blob and download
            const blob = new Blob([htmlContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const today = new Date();
            const fileName = `Stock_Report_${today.toISOString().split('T')[0]}.xls`;

            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            setExporting(false);
        } catch (err) {
            setError('Failed to export data: ' + (err.message || 'Unknown error'));
            setExporting(false);
            console.error('Export error:', err);
        }
    };

    // Helper function to generate HTML with colors (updated with Part No)
    const generateHTMLWithColors = (data) => {
        let html = `
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Stock Report</title>
            <style>
                table {
                    border-collapse: collapse;
                    width: 100%;
                    font-family: Arial, sans-serif;
                }
                th, td {
                    border: 1px solid #ddd;
                    padding: 8px;
                    text-align: left;
                }
                .inward-header {
                    background-color: #007bff;
                    color: white;
                    text-align: center;
                    font-weight: bold;
                }
                .outward-header {
                    background-color: #ffc107;
                    color: #000;
                    text-align: center;
                    font-weight: bold;
                }
                .closing-header {
                    background-color: #28a745;
                    color: white;
                    text-align: center;
                    font-weight: bold;
                }
                .sub-header {
                    background-color: #f2f2f2;
                    font-weight: bold;
                }
                .numeric-cell {
                    text-align: right;
                }
            </style>
        </head>
        <body>
            <table>
                <thead>
                    <tr>
                        <th rowspan="2">#</th>
                        <th rowspan="2">P.ID</th>
                        <th rowspan="2">Product Name</th>
                        <th rowspan="2">Part No</th>
                        <th rowspan="2">Product Type</th>
                        <th colspan="6" class="inward-header">INWARD</th>
                        <th colspan="6" class="outward-header">OUTWARD</th>
                        <th colspan="3" class="closing-header">CLOSING</th>
                    </tr>
                    <tr class="sub-header">
                        <th>Purchase Qty</th><th>Purchase Value</th><th>Production Qty</th>
                        <th>Production Value</th><th>Sales Return Qty</th><th>Sales Return Value</th>
                        <th>Sale Qty</th><th>Sale Value</th><th>Production Issue</th>
                        <th>Production Value</th><th>Purchase Return</th><th>Purchase Value</th>
                        <th>Closing Qty</th><th>WAC</th><th>Closing Value</th>
                    </tr>
                </thead>
                <tbody>
    `;

        data.forEach((item, index) => {
            html += `
                <tr>
                    <td>${index + 1}</td>
                    <td>${item.productid ?? 'N/A'}</td>
                    <td>${item.productname ?? 'N/A'}</td>
                    <td>${item.partno ?? 'N/A'}</td>
                    <td>${item.producttype ?? 'N/A'}</td>
                    <td class="numeric-cell">${Number(item.purchaseqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.purchasevalue ?? 0}</td>
                    <td class="numeric-cell">${Number(item.productioninwardqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.productioninwardvalue ?? 0}</td>
                    <td class="numeric-cell">${Number(item.salesreturnqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.salesreturnvalue ?? 0}</td>
                    <td class="numeric-cell">${Number(item.saleqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.salevalue ?? 0}</td>
                    <td class="numeric-cell">${Number(item.productionoutwardqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.productionoutwardvalue ?? 0}</td>
                    <td class="numeric-cell">${Number(item.purchasereturnqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.purchasereturnvalue ?? 0}</td>
                    <td class="numeric-cell">${Number(item.closingqty ?? 0).toFixed(2)}</td>
                    <td class="numeric-cell">${item.wac ?? 0}</td>
                    <td class="numeric-cell">${item.closingvalue ?? 0}</td>
                </tr>
            `;
        });

        html += `
                </tbody>
            </table>
        </body>
        </html>
    `;

        return html;
    };

    // Fetch data when component mounts
    useEffect(() => {
        fetchStockReport();
    }, []);

    // Page size handler
    const handlePageSizeChange = (e) => {
        const newSize = parseInt(e.target.value);
        setApiData(prev => ({
            ...prev,
            pageSize: newSize,
            pageNumber: 0
        }));
    };

    // Sort handler
    const handleSort = (field) => {
        const newDirection = sort.field === field && sort.direction === 'asc' ? 'desc' : 'asc';
        setSort({
            field,
            direction: newDirection
        });
        setApiData(prev => ({ ...prev, pageNumber: 0 }));
    };

    // Pagination handlers
    const handlePageChange = (page) => {
        setApiData(prev => ({ ...prev, pageNumber: page }));
    };

    const handlePreviousPage = () => {
        if (apiData.pageNumber > 0) {
            setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber - 1 }));
        }
    };

    const handleNextPage = () => {
        if (!apiData.last) {
            setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber + 1 }));
        }
    };

    // Render pagination numbers
    const renderPagination = () => {
        const totalPages = apiData.totalPages;
        const currentPage = apiData.pageNumber;
        const siblingsCount = 2;
        const firstPage = 0;
        const lastPage = totalPages - 1;
        let pageNumbers = [];

        const startPage = Math.max(firstPage, currentPage - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button
                    key={firstPage}
                    className={`stock-page-btn ${currentPage === firstPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(firstPage)}
                >
                    {firstPage + 1}
                </button>
            );
            if (startPage > firstPage + 2) {
                pageNumbers.push(<span key="dots-start" className="stock-page-dots">...</span>);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`stock-page-btn  ${currentPage === i ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i + 1}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            if (endPage < lastPage - 2) {
                pageNumbers.push(<span key="dots-end" className="stock-page-dots">...</span>);
            }
            pageNumbers.push(
                <button
                    key={lastPage}
                    className={`stock-page-btn  ${currentPage === lastPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(lastPage)}
                >
                    {lastPage + 1}
                </button>
            );
        }

        return pageNumbers;
    };

    // Fetch data when pagination or sorting changes
    useEffect(() => {
        fetchStockReport();
    }, [apiData.pageNumber, apiData.pageSize, sort.field, sort.direction]);

    // Perfect Sync Scrolling Effect
    useEffect(() => {
        const syncScroll = () => {
            const headerWrapper = document.querySelector('.stock-table-header-wrapper');
            const bodyWrapper = document.querySelector('.stock-table-body-wrapper');

            if (!headerWrapper || !bodyWrapper) return;

            const handleBodyScroll = () => {
                headerWrapper.scrollLeft = bodyWrapper.scrollLeft;
            };

            const handleHeaderScroll = () => {
                bodyWrapper.scrollLeft = headerWrapper.scrollLeft;
            };

            bodyWrapper.addEventListener('scroll', handleBodyScroll);
            headerWrapper.addEventListener('scroll', handleHeaderScroll);

            return () => {
                bodyWrapper.removeEventListener('scroll', handleBodyScroll);
                headerWrapper.removeEventListener('scroll', handleHeaderScroll);
            };
        };

        const timer = setTimeout(() => {
            syncScroll();
            const headerWrapper = document.querySelector('.stock-table-header-wrapper');
            const bodyWrapper = document.querySelector('.stock-table-body-wrapper');
            if (headerWrapper && bodyWrapper) {
                headerWrapper.scrollLeft = bodyWrapper.scrollLeft;
            }
        }, 150);

        return () => {
            clearTimeout(timer);
        };
    }, [apiData.content, loading]);

    return (
        <Card className="mt-4 stock-card">
            <Card.Header className="stock-header">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 className="mb-0">Stock In Hand Report</h4>

                </div>
                <button
                    onClick={exportToExcel}
                    disabled={exporting || loading || apiData.content.length === 0}
                    style={{
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        cursor: exporting ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    {exporting ? (
                        <>
                            <Spinner animation="border" size="sm" />
                            <span>Exporting...</span>
                        </>
                    ) : (
                        <>
                            <FaFileExcel size={18} />
                            <span>Export to Excel</span>
                        </>
                    )}
                </button>
            </Card.Header>

            <Card.Body>
                {/* Error Alert */}
                {error && (
                    <Alert variant="danger" onClose={() => setError(null)} dismissible>
                        {error}
                    </Alert>
                )}

                {/* Controls Section */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", paddingBottom: '8px' }}>
                    <div className="stock-entries-control">
                        <span className="stock-entries-label">Show entries:</span>
                        <Form.Select
                            className="stock-entries-select"
                            onChange={handlePageSizeChange}
                            value={apiData.pageSize}
                            disabled={loading}
                            style={{ width: '100px', display: 'inline-block' }}
                        >
                            {pageSizeOptions.map((item) => (
                                <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                        </Form.Select>
                    </div>

                    <div className="stock-search-box mt-2 mt-md-0">
                        <input
                            type="search"
                            className="form-control"
                            placeholder="Search by Product Name"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            style={{ maxWidth: '300px' }}
                        />
                    </div>
                </div>

                {/* Rest of your table code remains same... */}
                {/* Table Section */}
                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" role="status" variant="primary">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <p className="mt-2">Loading stock data...</p>
                    </div>
                ) : apiData.content.length > 0 ? (
                    <>
                        {/* Main Container with Perfect Sync */}
                        <div className="stock-table-main-container">

                            {/* Header Table - Fixed at top */}
                            <div className="stock-table-header-wrapper">
                                <Table bordered className="stock-table-common stock-table-header">
                                    <colgroup>
                                        <col /> {/* # */}
                                        <col /> {/* Product ID */}
                                        <col /> {/* Product Name */}
                                        <col /> {/* Part No */}
                                        <col /> {/* Product Type */}
                                        <col /><col /><col /><col /><col /><col /> {/* INWARD */}
                                        <col /><col /><col /><col /><col /><col /> {/* OUTWARD */}
                                        <col /><col /><col /> {/* CLOSING */}
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th rowSpan="2">#</th>
                                            <th rowSpan="2" style={{ cursor: 'pointer' }} onClick={() => handleSort('productid')}>
                                                P.ID
                                                {sort.field === 'productid' && (
                                                    <span className="ms-1">{sort.direction === 'asc' ? '↑' : '↓'}</span>
                                                )}
                                            </th>
                                            <th rowSpan="2">Product Name</th>
                                            <th rowSpan="2">Part No</th>
                                            <th rowSpan="2">Product Type</th>
                                            <th colSpan="6" className="text-center bg-primary text-white py-1">INWARD</th>
                                            <th colSpan="6" className="text-center bg-warning text-dark py-1">OUTWARD</th>
                                            <th colSpan="3" className="text-center bg-success text-white py-1">CLOSING</th>
                                        </tr>
                                        <tr>
                                            <th>Purchase Qty</th><th>Purchase Value</th><th>Production Qty</th>
                                            <th>Production Value</th><th>Sales Return Qty</th><th>Sales Return Value</th>
                                            <th>Sale Qty</th><th>Sale Value</th><th>Production Issue</th>
                                            <th>Production Value</th><th>Purchase Return</th><th>Purchase Value</th>
                                            <th>Closing Qty</th><th>WAC</th><th>Closing Value</th>
                                        </tr>
                                    </thead>
                                </Table>
                            </div>

                            {/* Body Table - Scrollable */}
                            <div className="stock-table-body-wrapper" id="stock-table-body">
                                <Table bordered className="stock-table-common stock-table-body">
                                    <colgroup>
                                        <col /><col /><col /><col /><col />
                                        <col /><col /><col /><col /><col /><col />
                                        <col /><col /><col /><col /><col /><col />
                                        <col /><col /><col />
                                    </colgroup>
                                    <tbody>
                                        {apiData.content.map((item, index) => (
                                            <tr key={item.productid}>
                                                <td>{index + 1}</td>
                                                <td>{item.productid ?? 'N/A'}</td>
                                                <td className="text-start">{item.productname ?? 'N/A'}</td>
                                                <td className="text-start">{item.partno ?? 'N/A'}</td>
                                                <td>{item.producttype ?? 'N/A'}</td>

                                                <td className="numeric-cell">{Number(item.purchaseqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.purchasevalue ?? 0}</td>
                                                <td className="numeric-cell">{Number(item.productioninwardqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.productioninwardvalue ?? 0}</td>
                                                <td className="numeric-cell">{Number(item.salesreturnqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.salesreturnvalue ?? 0}</td>

                                                <td className="numeric-cell">{Number(item.saleqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.salevalue ?? 0}</td>
                                                <td className="numeric-cell">{Number(item.productionoutwardqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.productionoutwardvalue ?? 0}</td>
                                                <td className="numeric-cell">{Number(item.purchasereturnqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.purchasereturnvalue ?? 0}</td>

                                                <td className="numeric-cell">{Number(item.closingqty ?? 0).toFixed(1)}</td>
                                                <td className="numeric-cell">{item.wac ?? 0}</td>
                                                <td className="numeric-cell">{item.closingvalue ?? 0}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        {/* Pagination Controls */}
                        <div className="stock-pagination mt-2">
                            <span className="stock-pagination-info">
                                Showing {apiData.content.length} of {apiData.totalElements} entries
                            </span>

                            <div className="stock-pagination-controls">
                                <button
                                    className={`brand-pagination-btn ${apiData.pageNumber === 0 ? 'disabled' : ''}`}
                                    onClick={handlePreviousPage}
                                    disabled={apiData.pageNumber === 0 || loading}
                                >
                                    <IoIosArrowBack />
                                </button>

                                <div className="stock-pagination-pages">
                                    {renderPagination()}
                                </div>

                                <button
                                    className={`brand-pagination-btn ${apiData.last ? 'disabled' : ''}`}
                                    onClick={handleNextPage}
                                    disabled={apiData.last || loading}
                                >
                                    <IoIosArrowForward />
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    /* No Data Message in Table Body */
                    <div className="stock-table-main-container">
                        {/* Header Table - Still show header even when no data */}
                        <div className="stock-table-header-wrapper">
                            <Table bordered className="stock-table-common stock-table-header">
                                <colgroup>
                                    <col /><col /><col /><col /><col />
                                    <col /><col /><col /><col /><col /><col />
                                    <col /><col /><col /><col /><col /><col />
                                    <col /><col /><col />
                                </colgroup>
                                <thead className="table-dark">
                                    <tr>
                                        <th rowSpan="2">#</th>
                                        <th rowSpan="2" style={{ cursor: 'pointer' }} onClick={() => handleSort('productid')}>
                                            P.ID
                                            {sort.field === 'productid' && (
                                                <span className="ms-1">{sort.direction === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                        </th>
                                        <th rowSpan="2">Product Name</th>
                                        <th rowSpan="2">Part No</th>
                                        <th rowSpan="2">Product Type</th>
                                        <th colSpan="6" className="text-center bg-primary text-white py-1">INWARD</th>
                                        <th colSpan="6" className="text-center bg-warning text-dark py-1">OUTWARD</th>
                                        <th colSpan="3" className="text-center bg-success text-white py-1">CLOSING</th>
                                    </tr>
                                    <tr>
                                        <th>Purchase Qty</th><th>Purchase Value</th><th>Production Qty</th>
                                        <th>Production Value</th><th>Sales Return Qty</th><th>Sales Return Value</th>
                                        <th>Sale Qty</th><th>Sale Value</th><th>Production Issue</th>
                                        <th>Production Value</th><th>Purchase Return</th><th>Purchase Value</th>
                                        <th>Closing Qty</th><th>WAC</th><th>Closing Value</th>
                                    </tr>
                                </thead>
                            </Table>
                        </div>

                        {/* Body Table with No Data Message */}
                        <div className="stock-table-body-wrapper" id="stock-table-body">
                            <Table bordered className="stock-table-common stock-table-body">
                                <colgroup>
                                    <col /><col /><col /><col /><col />
                                    <col /><col /><col /><col /><col /><col />
                                    <col /><col /><col /><col /><col /><col />
                                    <col /><col /><col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <td colSpan="20" className="text-center py-4">
                                            <h5>
                                                {productName.trim() ?
                                                    `No stock data found for product: "${productName}"` :
                                                    'No stock data available'
                                                }
                                            </h5>
                                            <p className="text-muted">
                                                {productName.trim() ?
                                                    'Try searching with a different product name' :
                                                    'No data found for today\'s date'
                                                }
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default StockDetailsReportsValue;